import { render, staticRenderFns } from "./BudgetAmount.vue?vue&type=template&id=41dc9c71&"
import script from "./BudgetAmount.vue?vue&type=script&lang=ts&"
export * from "./BudgetAmount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports